export default {
  path: '/meter-models',
  component: () => import('@/components/pages/MeterModels/MeterModels.vue')
}
